import {
	PTZ_PRIVILEGE_INITIAL,
	PTZ_PRIVILEGE_UPDATE,
	PTZ_PRIVILEGE_STREAM_STARTED,
	PTZ_PRIVILEGE_STREAM_STOPPED,
	PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED,
	PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED
} from "./actionTypes";

const initialState = {
	streams: {}
};

const ptzPrivileges = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case PTZ_PRIVILEGE_INITIAL: {
			const { cameraId, snapshot } = payload;
			return {
				...state,
				[cameraId]: { ...snapshot }
			};
		}

		case PTZ_PRIVILEGE_UPDATE: {
			const { cameraId, snapshot } = payload;
			return {
				...state,
				[cameraId]: {
					...(state[cameraId] || {}),
					...snapshot
				}
			};
		}

		case PTZ_PRIVILEGE_STREAM_STARTED: {
			const { cameraId, contextId, subscription } = action.payload;
			return {
				...state,
				streams: {
					...state.streams,
					[cameraId]: {
						subscription,
						contextIds: [contextId]
					}
				}
			};
		}

		case PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED: {
			const { cameraId, contextId } = action.payload;
			const entry = state.streams[cameraId];
			if (!entry) return state;

			// avoid duplicates
			if (entry.contextIds.includes(contextId)) return state;

			return {
				...state,
				streams: {
					...state.streams,
					[cameraId]: {
						...entry,
						contextIds: [...entry.contextIds, contextId]
					}
				}
			};
		}

		case PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED: {
			const { cameraId, contextId } = action.payload;
			const entry = state.streams[cameraId];
			if (!entry) return state;

			return {
				...state,
				streams: {
					...state.streams,
					[cameraId]: {
						...entry,
						contextIds: entry.contextIds.filter(id => id !== contextId)
					}
				}
			};
		}

		case PTZ_PRIVILEGE_STREAM_STOPPED: {
			const { cameraId } = action.payload;
			const { [cameraId]: _, ...rest } = state.streams;
			return {
				...state,
				streams: rest
			};
		}
		default:
			return state;
	}
};

export default ptzPrivileges;
